import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { NgxSpinnerService } from "ngx-spinner";
import { RilrService } from "../services/rilr.service";
import { HelperService } from "../services/helper.service";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import { IOption } from "ng-select";
import { Location } from "@angular/common";
// import { AssessmentMasterService } from "../services/assesment-master.service";
import { TosterMessageService } from "../services/toster-message.service";

@Component({
  selector: "app-corrective-action-modal",
  templateUrl: "./corrective-action-modal.component.html",
  styleUrls: ["./corrective-action-modal.component.scss"],
  providers: [RilrService],
})
export class CorrectiveActionModalComponent implements OnInit {
  public masterData: any = {};
  public company: Array<IOption> = [];
  public priorityArr: Array<IOption> = [];
  public actionAreaSelectionArr: Array<IOption> = [];
  public fileChanges: boolean = false;
  public attachments: any = [];
  colorTheme = "theme-blue";
  bsConfig: Partial<BsDatepickerConfig>;
  bsValue = new Date();
  public isEdit: number;
  public policyBaseAction: number = 0;
  public areaActionFalse: number = 0;
  public reportID: number;
  public documentSystemID: number;

  public obj_ass_autoId: number; //OBJECTIVE & ASSESSMENT ONLY

  public selectedValues: Array<IOption> = [];
  public selectedValues2: Array<IOption> = [];
  public assessment_id: number;

  public url_id: number;
  public url_name: any;

  public isAITemplate: number;
  aiAreas: any = [
    { value: 1, label: "In Hierarchy of Control - Elimination" },
    { value: 2, label: "Substitution" },
    { value: 3, label: "Engineering Control" },
    { value: 4, label: "Administrative Control" },
    { value: 5, label: "Assurance Action" },
  ];

  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;
  @ViewChild("errorMessageHtml1") errorMessageHtml1: any;
  @ViewChild("errorMessageHtml2") errorMessageHtml2: any;
  @ViewChild("f") form: any;
  public submitted: boolean = false;
  public isValid: boolean = true;
  public firstDayOfYear: any;
  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  public htmlErrorMessage1: string = "Title length exceeded.";
  public htmlErrorMessage2: string = "Employee is required.";
  AssessmentMasterTab2: any = [];

  public employeeOption: Array<IOption> = [];
  public companySystemID = +this.helperService.getSelectedCompanyId();

  yesNoArr: any = [
    { value: 0, label: "Open" },
    { value: 2, label: "Closed" },
  ];

  @Output() tableReload: EventEmitter<any> = new EventEmitter();

  constructor(
    public bsModalRef: BsModalRef,
    private rilrService: RilrService,
    private spinner: NgxSpinnerService,
    private helperService: HelperService,
    private location: Location,
    private modalService: BsModalService,
    private tosterMessageService: TosterMessageService
  ) // private assessmentMasterService: AssessmentMasterService,
  {
    this.bsConfig = Object.assign(
      {},
      { containerClass: this.colorTheme, dateInputFormat: "DD/MM/YYYY" }
    );
    this.masterData.IncidateDate = this.bsValue;

    // this.getAssessmentMasterTab2();
  }

  ngOnInit() {
    // //console.log(this.actionAreaSelectionArr);
    setTimeout(() => {
      if (this.policyBaseAction == 0) {
        this.getFormData();
        this.editFormLoad();
      }

      //console.log(this.selectedValues);
      //console.log(this.selectedValues2);
      //console.log(this.reportID);
      //console.log(this.assessment_id);
      //console.log(this.documentSystemID);

      //console.log(this.url_id);
      //console.log(this.url_name);

      // this.getAssessmentMasterTab2();
    }, 0);
  }

  getFormData() {
    const that = this;

    // this.getAssessmentMasterTab2();

    that.rilrService
      .getReportFormData()
      .get({
        companySystemID: that.companySystemID,
        type: "create",
        documentSystemID: that.documentSystemID,
      })
      .subscribe(
        (data) => {
          var resp = data.data.data;
          this.yesNoArr = this.helperService.setSelect2DropDownOptions(
            resp.ticketStatuses,
            "purpose_of_status_id",
            "name"
          );
          this.yesNoArr = this.yesNoArr.filter((s) => s.value != 3);
          if (resp.lastCutOffDate != null) {
            that.firstDayOfYear = new Date(resp.lastCutOffDate);
          }
        },
        (error) => {
          that.spinner.hide();
        }
      );
  }

  editFormLoad() {
    setTimeout(() => {
      if (this.isEdit == 1) {
        this.getEmployees(this.masterData.personResEmpID);
        this.masterData.submitted = this.helperService.setSelectedValue(
          this.masterData.submitted
        );
      }
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("corrective_action_closed");
  }

  closeSuccessModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("corrective_action_success");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("corrective_action_success");
  }

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  public typehead(value: any): void {
    if (value.length > 2) {
      this.getEmployees(value);
    } else {
      this.employeeOption = [];
    }
  }

  getEmployees(value: any) {
    const that = this;
    that.rilrService
      .getTypeheadEmployees()
      .get({
        search: value,
        companySystemID: that.companySystemID,
      })
      .subscribe(
        (resp) => {
          var tempOption = resp.data.data;
          that.employeeOption = [];
          that.employeeOption =
            that.helperService.setSelect2DropDownOptionsConcatLabelThree(
              tempOption,
              "employeeSystemID",
              "empName",
              "countryName",
              "description"
            );
          if (that.isEdit == 1) {
            setTimeout(() => {
              that.masterData.personResEmpSystemID =
                that.helperService.setSelectedValue(
                  that.masterData.personResEmpSystemID
                );
            }, 0);
          }
        },
        (err) => {
          //console.log(err);
          that.employeeOption = [];
        }
      );
  }

  storeCorrectiveActionMultiple() {
    this.spinner.show();
    const that = this;
    const tempArray = {};
    that.isValid = false;
    that.masterData.reportSystemID = that.reportID;
    that.masterData.companySystemID = that.companySystemID;
    that.masterData.documentSystemID = that.documentSystemID;
    that.masterData.policyBaseAction = that.policyBaseAction;
    that.masterData.policyBaseAction = 3;
    that.masterData.host = window.location.origin;
    that.masterData.targetDate = that.helperService.formatDate(
      that.masterData.targetDate
    );
    that.masterData.expectedCompletionDate = that.helperService.formatDate(
      that.masterData.expectedCompletionDate
    );

    that.masterData.obj_ass_autoId = that.obj_ass_autoId; //OBJECTIVE & ASSESSMENT ONLY
    that.masterData.selectedValues2 = that.selectedValues2;
    this.masterData.createdByUserSystemID = +this.helperService.getuserID();

    //Pass URL path
    that.masterData.url_navigation = that.url_name + "/" + that.url_id;

    tempArray["master"] = that.masterData;
    tempArray["attachments"] = that.attachments;
    //console.log(tempArray);

    // //console.log(that.masterData.personResEmpSystemID);
    // if(that.masterData.personResEmpSystemID === undefined || that.masterData.personResEmpSystemID === null || !that.masterData.personResEmpSystemID) {
    //   this.tosterMessageService.showError("Sorry", "Please fill the employee field.");
    //   this.spinner.hide();
    //   return;
    // }

    if (that.masterData.actionTitle.length > 500) {
      this.errorMessageHtml1.show();
      that.isValid = true;
      that.spinner.hide();
    } else if (!that.masterData.personResEmpSystemID) {
      this.errorMessageHtml2.show();
      that.isValid = true;
      that.spinner.hide();
    } else {
      that.rilrService
        .reportCorrectiveActionsCRUDMultiple()
        .post(tempArray)
        .subscribe(
          (resp) => {
            that.masterData = {};
            that.successMsg = "";
            if (that.isEdit === 1) {
              that.successMsg = "Successfully updated corrective action";
            } else if (that.isEdit === 0) {
              that.successMsg = "Successfully added corrective action";
            }
            that.showSuccessHtml();
            that.closeSuccessModal();
            this.tableReload.emit();
            that.spinner.hide();
          },
          (error) => {
            that.htmlErrorMessage = "";
            if (error.status === 500) {
              that.isValid = true;
              that.htmlErrorMessage = error.data.message;
              that.showErrorHtml();
            } else if (error.status === 422) {
              that.isValid = true;
              that.htmlErrorMessage = that.helperService.serverSideError422(
                error.data.message
              );
              that.showErrorHtml();
            }
            that.spinner.hide();
          }
        );
    }
  }

  public createAction() {
    if (this.form.form.valid) {
      this.submit();
    }
  }

  public addAttachment(list) {
    this.attachments = list;
    // this.storeCorrectiveAction();
    if (this.documentSystemID == 36) {
      this.storeCorrectiveActionMultiple();
    } else {
      this.storeCorrectiveAction();
    }
  }

  public submit() {
    // this.storeCorrectiveAction();    //Twise submit corrective action!
    if (!this.submitted) {
      // this.fileChanges = !this.fileChanges;
      this.fileChanges = !this.fileChanges;
      // this.storeCorrectiveAction();

      if (this.documentSystemID == 36) {
        this.storeCorrectiveActionMultiple();
      } else {
        this.storeCorrectiveAction();
      }
    }
  }

  updateActionTitle() {
    const description = this.masterData.actionDescription;

    // Update actionTitle based on the first 100 characters or the first sentence of actionDescription
    const limit = 100;
    const truncatedDescription =
      description.length > limit
        ? description.substring(0, limit)
        : description;

    this.masterData.actionTitle = truncatedDescription;

    // Alternatively, you can update actionTitle based on the first sentence:
    // const firstSentence = description.split('.')[0];
    // this.masterData.actionTitle = firstSentence;
  }

  // getAssessmentMasterTab2() {

  //   //console.log(this.reportID);
  //   //console.log(this.assessment_id);

  //   this.rilrService
  //   .getEmployeeAnswers(this.reportID, this.assessment_id)
  //   .get()
  //   .subscribe(
  //     (resp) => {
  //       const data = JSON.parse(resp._body);
  //       //console.log(data);
  //       this.AssessmentMasterTab2 = data;
  //       //console.log(this.AssessmentMasterTab2);
  //     },
  //     (error) => {
  //       //console.log(error);
  //       let message;
  //       if (error.status === 500) {
  //         message = error.data.message;
  //       } else {
  //         message = "Error Occurred 2";
  //       }
  //       // this.tosterMessageService.showError("Error", message);
  //     }
  //   );
  // }

  storeCorrectiveAction() {
    this.spinner.show();
    const that = this;
    const tempArray = {};
    that.isValid = false;
    // that.spinner.show();
    that.masterData.reportSystemID = that.reportID;
    that.masterData.companySystemID = that.companySystemID;
    that.masterData.documentSystemID = that.documentSystemID;
    that.masterData.policyBaseAction = that.policyBaseAction;
    that.masterData.policyBaseAction = 3;
    that.masterData.host = window.location.origin;
    that.masterData.targetDate = that.helperService.formatDate(
      that.masterData.targetDate
    );
    that.masterData.expectedCompletionDate = that.helperService.formatDate(
      that.masterData.expectedCompletionDate
    );

    that.masterData.obj_ass_autoId = that.obj_ass_autoId; //OBJECTIVE & ASSESSMENT ONLY

    //Pass URL path
    that.masterData.url_navigation = that.url_name + "/" + that.url_id;

    tempArray["master"] = that.masterData;
    tempArray["attachments"] = that.attachments;
    //console.log(tempArray);

    // if(that.masterData.personResEmpSystemID === undefined || that.masterData.personResEmpSystemID === null || !that.masterData.personResEmpSystemID) {
    //   this.tosterMessageService.showError("Sorry", "Please fill the employee field.");
    //   this.spinner.hide();
    //   return;
    // }

    if (that.masterData.actionTitle.length > 500) {
      this.errorMessageHtml1.show();
      that.isValid = true;
      that.spinner.hide();
    } else if (!that.masterData.personResEmpSystemID) {
      this.errorMessageHtml2.show();
      that.isValid = true;
      that.spinner.hide();
    } else {
      that.rilrService
        .reportCorrectiveActionsCRUD()
        .post(tempArray)
        .subscribe(
          (resp) => {
            that.masterData = {};
            that.successMsg = "";
            if (that.isEdit === 1) {
              that.successMsg = "Successfully updated corrective action";
            } else if (that.isEdit === 0) {
              that.successMsg = "Successfully added corrective action";
            }
            that.showSuccessHtml();
            that.closeSuccessModal();
            this.tableReload.emit();
            that.spinner.hide();
          },
          (error) => {
            that.htmlErrorMessage = "";
            if (error.status === 500) {
              that.isValid = true;
              that.htmlErrorMessage = error.data.message;
              that.showErrorHtml();
            } else if (error.status === 422) {
              that.isValid = true;
              that.htmlErrorMessage = that.helperService.serverSideError422(
                error.data.message
              );
              that.showErrorHtml();
            }
            that.spinner.hide();
          }
        );
      this.tableReload.emit();
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/corrective-action-modal/corrective-action-modal.component.ts